
import Icon from "../Utils/Icon";

const Error = props => {
  const error = props.error;
  if (!error) {
    return null;
  }

  return (
    <p className="form-field-error text-danger d-flex align-items-center">
      <Icon className="fas fa-exclamation-circle margin-right-xs" />
      {error}
    </p>
  );
};

export default Error;
